module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="paylateBnr__title">\n    ';
 if (!appConfig.isPaylateShare) { 
__p+='\n        <h3>Покупайте сейчас — платите&nbsp;потом!</h3>\n    ';
 } else { 
__p+='\n        <h3>\n            Получите 5 000<span class="rubl rubl_bold">o</span> за покупку тура в рассрочку!\n        </h3>\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};
